import { render, staticRenderFns } from "./PaymentFilter.vue?vue&type=template&id=22c67ae4&scoped=true&"
import script from "./PaymentFilter.vue?vue&type=script&lang=js&"
export * from "./PaymentFilter.vue?vue&type=script&lang=js&"
import style0 from "./PaymentFilter.vue?vue&type=style&index=0&id=22c67ae4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c67ae4",
  null
  
)

export default component.exports